import { Component, Input, ViewChild } from '@angular/core';
import { EventService } from "../../../../services/event.service";
import { FileHolder, ImageUploadComponent } from "angular2-image-upload";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ImageService } from '../../../../services/image.service';
import {NationalTeamsService} from "../../../../services/national-teams.service";
import {FundraisingViewService} from "../../../../services/fundraising-view.service";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss']
})
export class UploadComponent {
    public currentFile: FileHolder;
    disableSave: boolean;

    @Input() isTeam: boolean = false;
    @Input() saveBtnLabel: string = 'Save';
    @ViewChild('imageUploadComponent', { static: true })
    imageUploadComponent: ImageUploadComponent;

    constructor(public eventService: EventService,
                public activeModal: NgbActiveModal,
                public imageService: ImageService,
                private ToastrService: ToastrService,
                private nationalTeamsService: NationalTeamsService,
                private fundraisingViewService: FundraisingViewService) {

        this.disableSave = true;
    }

    onImageSelected(file: FileHolder) {
        this.currentFile = file;
        this.disableSave = false;
    }

    onImageRemoved(file: FileHolder) {
        this.currentFile = null;
        this.disableSave = true;
    }

    save() {
        this.disableSave = true;
        let url = null;
        if (this.isTeam) {
            if(this.fundraisingViewService.isNationalTeamView()) {
                url = '/api/v1/teams/' + this.nationalTeamsService.selectedNationalTeam.teamId + '/' + 0 + '/images'; //the participant id is ignored in this case
            } else {
                url = '/api/v1/teams/' + this.eventService.selectedEvent.gql.Participant[0].team.teamId + '/' + this.eventService.selectedEvent.participantId + '/images';
            }
        } else {
            url = '/api/v1/user/participant/' + this.eventService.selectedEvent.participantId + '/images';
        }
        this.imageService.postImage(url, this.currentFile.file)
            .subscribe(res => {
                let uploadedFileResponse = res;
                uploadedFileResponse[0].imagePath = this.imageService.formatUrl(uploadedFileResponse[0].imagePath);
                this.eventService.getConstituentImages(true).subscribe(() => {});
                this.activeModal.close(uploadedFileResponse[0]);
                this.disableSave = false;
            }, err => {
                this.ToastrService.error('Upload failed. You can only upload a JPG, GIF, or PNG.');
                this.disableSave = false;
            });
    }
}
